import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class CompanyCaseMode extends Resource {
    public override type = 'companyCaseModes';

    @prop()
    public companyId!: string;

    @prop()
    public caseModeId!: string;
}
